import { useTranslation } from 'react-i18next';
import { useMatch, useNavigate, useParams } from 'react-router-dom';
import {
  RESTAURANT_USER_ROLE,
  useAuthUserRestaurant,
  useGetSingleRestaurantCompanyTrackLocationQuery,
} from '@durma-soft/gros-sdk';

import { Alert } from '@/components/shared/alert';
import { Modal } from '@/components/shared/modal';
import { ModalFormSkeleton } from '@/components/shared/modal-form-skeleton';
import { EditRestaurantCompanyTrackLocationForm } from '@/components/restaurant/companies/edit-restaurant-company-track-location-form';

export const EditRestaurantCompanyTrackLocationModal = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { companyId, trackLocationId } = useParams();

  if (!companyId) {
    throw new Error('Company ID is required getting track location');
  }

  const restaurant = useAuthUserRestaurant();
  const hasEditPermission = restaurant.role !== RESTAURANT_USER_ROLE.EMPLOYEE;

  const {
    data: trackLocation,
    isSuccess,
    isError,
    isLoading,
  } = useGetSingleRestaurantCompanyTrackLocationQuery({
    restaurant_id: restaurant.id,
    company_id: Number(companyId),
    track_location_id: Number(trackLocationId),
  });

  const closeModal = () =>
    navigate(`/restaurant/companies/${companyId}/track-locations`);

  const isModalOpen = Boolean(
    useMatch({
      path: '/restaurant/companies/:comapnyId/track-locations/edit/:trackLocationId',
    }),
  );

  return (
    <Modal
      key={trackLocationId}
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      title={t('company.track-location.edit')}
      description={t('company.track-location.edit-details')}
    >
      {isLoading && <ModalFormSkeleton />}
      {!hasEditPermission && (
        <Alert
          variant="destructive"
          title={t('common.edit-not-allowed')}
          description={t('common.edit-not-allowed-description')}
        />
      )}
      {isError && hasEditPermission && (
        <Alert
          variant="destructive"
          title={t('common.error')}
          description={t('common.try-later')}
        />
      )}
      {isSuccess && hasEditPermission && (
        <EditRestaurantCompanyTrackLocationForm
          trackLocation={trackLocation}
          closeModal={closeModal}
        />
      )}
    </Modal>
  );
};
